<script lang="ts">
	import { Item, Text, Graphic } from '@smui/list/styled';
	import { Link } from 'svelte-routing';
	import type { LinkPropsType } from 'Routing';

	export let to = '';
	export let graphic: string;

	let active = false;

	$: style = active ? 'background: var(--mdc-theme-secondary); color: white' : '';
	$: styleIcon = active ? 'color: white;' : '';

	function getProps(params: LinkPropsType) {
		active = params.isCurrent;
	}
</script>

<Link {to} {getProps}>
	<Item {style} on:click>
		<Graphic style={styleIcon} class="material-icons" aria-hidden="true">{graphic}</Graphic>
		<Text>
			<slot />
		</Text>
	</Item>
</Link>
